// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__19Ago","options":"AnswerScale_options__1bz9x","selected":"AnswerScale_selected__3TNbg"};